module.exports = __webpack_public_path__ + "static/img/logo.e62d01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 1